import { cn } from '@/lib/utils';

interface FormNavigationProps {
  sections: { id: string; label: string }[];
  expandedSections?: string[];
  activeSectionId?: string;
  onNavigate?: (id: string) => void;
}

export function FormNavigation({
  sections,
  expandedSections = [],
  activeSectionId,
  onNavigate,
}: FormNavigationProps) {
  return (
    <nav
      className="sticky-section-nav"
      aria-label="Section navigation"
      data-test-id="form-navigation"
    >
      <ul className="space-y-2" data-test-id="navigation-list">
        {sections.map((item) => {
          const isExpanded = expandedSections.includes(item.id);
          const isActive = activeSectionId === item.id && isExpanded;
          return (
            <li
              key={item.id}
              data-test-id={`nav-item-${item.id}`}
              data-expanded={isExpanded || undefined}
              data-active={isActive || undefined}
            >
              <button
                type="button"
                onClick={() => onNavigate?.(item.id)}
                className={cn(
                  'section-nav-link block w-full text-left px-4 py-2 text-sm rounded-md transition-colors',
                  isExpanded &&
                    'bg-blue-50 text-blue-700 ring-1 ring-blue-200 dark:bg-blue-950/30 dark:text-blue-300 dark:ring-blue-900',
                  isActive &&
                    'bg-blue-100 text-blue-900 ring-2 ring-blue-400 dark:bg-blue-900/50 dark:text-blue-200 dark:ring-blue-700'
                )}
                aria-expanded={isExpanded}
                aria-current={isActive ? 'true' : undefined}
                data-test-id={`nav-link-${item.id}`}
              >
                {item.label}
              </button>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
